const cardIconStyle = {
  cardIcon: {
    background: "linear-gradient(60deg, #d73312, #d70206)",
  },
};

export default cardIconStyle;
